import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Grid } from '@mui/material';
import { isArray } from 'lodash';
import React, { useEffect } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { VerificationAgencyClientService } from '../../../Component/Api/VerificationAgency/VerificationAgencyClient/VerificationAgencyClientService';
import AppCheckbox from '../../../Component/Common/Components/FormValidationInputs/AppCheckbox';
import AppTextInput from '../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { MDButton } from '../../../Component/Common/Components/MDButton';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import { VerificationAgencyClient } from '../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';
import { ReferredByValidationSchema } from './ReferredByValidationSchema';


interface IReferredBy {
    token: string;
    setHandleNextCount: (i: number) => void;
    handleNextCount: number;
}
export const ReferredByExternalPage = (props: IReferredBy) => {

    const verificationCompany = useRecoilValue(VerificationCompanyAtom);

    const [loading, setLoading] = React.useState(false);

    const { control, handleSubmit, formState: { isSubmitting }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(ReferredByValidationSchema),
    });

    const [isConsultantUsed, setIsConsultantUsed] = React.useState(false)

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestData = {
                vaClientId: verificationCompany.vaClientId,
                name: data.name,
                surname: data.surname,
                email: data.email,
                isConsultantUsed: data.isConsultantUsed,
                consultantName: data.consultantName,
                consultantEmail: data.consultantEmail,
                token: props.token
            } as VerificationAgencyClient.ReferredByTempAccessDto;

            const response = await VerificationAgencyClientService.UpdateReferredByExternalPage(requestData);
            props.setHandleNextCount(props.handleNextCount + 1);
            toast.success("Referred By Details Saved");
        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        }
    }

    const getReferredBy = async () => {

        const id = verificationCompany.vaClientId;
        if (id !== 0) {
            try {
                const response = await VerificationAgencyClientService.GetReferredByExternalPage(id, props.token);

                const formData = {
                    vaClientId: verificationCompany.vaClientId,
                    name: response.data.name,
                    surname: response.data.surname,
                    email: response.data.email,
                    isConsultantUsed: response.data.isConsultantUsed,
                    consultantName: response.data.consultantName,
                    consultantEmail: response.data.consultantEmail
                };
                setIsConsultantUsed(response.data.isConsultantUsed ?? false);
                reset(formData);
            } catch (error) {
                console.log(error);
            }
        }
    }

    useEffect(() => {
        setLoading(true);
        getReferredBy();
        setLoading(false);
    }, [])


    return (
        <Box>
            <MDTypography color='#000000' variant='h5' fontWeight='bold' >
                Referred By
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px", paddingBottom: "15px", paddingTop: "8px", color: "#727272" }}>
                This aids in tracing business connections and referrals, nurturing a supportive network within the BEE ecosystem.
            </MDTypography>
            <form id='ReferredByForm' onSubmit={handleSubmit(handleDataSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <Box>
                            <AppTextInput control={control} name="name" label="Name" size={"small"} />
                        </Box>
                        <Box mt={2}>
                            <AppTextInput control={control} name="email" label="Email" size={"small"} />
                        </Box>
                        <Box mt={2}>

                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box>
                            <AppTextInput control={control} name="surname" label="Surname" size={"small"} />
                        </Box>
                    </Grid>
                </Grid>
                <MDTypography color='primary' fontSize="14px" fontWeight='bold' paddingBottom='8px'>
                    CONSULTANT INFORMATION
                </MDTypography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Box>
                            <AppCheckbox
                                control={control}
                                name="isConsultantUsed"
                                label="Consultant Used"
                                disabled={false}
                                onChange={(e) => setIsConsultantUsed(e.target.checked)}
                            />
                            {isConsultantUsed && (
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Box width="100%">
                                            <AppTextInput
                                                control={control}
                                                name="consultantName"
                                                label="Consultant's Name"
                                                size={"small"}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box width="100%">
                                            <AppTextInput
                                                control={control}
                                                name="consultantEmail"
                                                label="Consultant's Email"
                                                size={"small"}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
                <Box mt={3} width='100%' display='flex' justifyContent='space-between'>
                    <Box>
                        <MDButton variant='outlined' color='secondary' onClick={() => { props.setHandleNextCount(props.handleNextCount - 1); }}>
                            Previous
                        </MDButton>
                    </Box>
                    <LoadingButton loading={isSubmitting} variant='contained' form='ReferredByForm' type="submit" color='primary'>
                        next
                    </LoadingButton>
                </Box>
            </form>
        </Box>
    )
}
